import React from 'react'

// Carried over from the old hacklab-website repo's Footer.js — confirm these
// still point at the right accounts post-rebrand (same handles, or new
// ones?) and swap here if not. Both Footer and ContactSection import from
// here so there's one place to update.
export const SOCIAL_LINKS=[
    {
        name: 'Instagram',
        href: 'https://www.instagram.com/the.hack.lab/',
        icon: (
            <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.8' width='20' height='20'>
                <rect x='3' y='3' width='18' height='18' rx='5' />
                <circle cx='12' cy='12' r='4' />
                <circle cx='17.2' cy='6.8' r='1' fill='currentColor' stroke='none' />
            </svg>
        ),
    },
    {
        name: 'LinkedIn',
        href: 'https://www.linkedin.com/company/thehacklab/',
        icon: (
            <svg viewBox='0 0 24 24' fill='currentColor' width='20' height='20'>
                <path d='M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM3 9h4v12H3zM9 9h3.8v1.7h.05c.53-1 1.83-2.05 3.77-2.05 4.03 0 4.78 2.65 4.78 6.1V21h-4v-5.6c0-1.34-.02-3.07-1.87-3.07-1.87 0-2.16 1.46-2.16 2.97V21H9z' />
            </svg>
        ),
    },
]

export const CONTACT_EMAIL='as.hacklab@unibocconi.it'
